/*
 * Provider presets. Both Alibaba Qwen and Xiaomi MiMo expose an
 * OpenAI-compatible /chat/completions endpoint, so we can talk to both with
 * one client by swapping baseUrl / model / apiKey.
 *
 * NOTE on baseUrl: when you run the bundled proxy (npm run proxy) the task pane
 * should target the proxy (http://localhost:3001/<providerId>) to avoid CORS and
 * keep keys off the page. The "direct" baseUrl below is what the proxy forwards
 * to, and is also used if you call the provider directly.
 */

export const PROVIDERS = {
  alibaba: {
    id: "alibaba",
    label: "Alibaba TokenPlan (coding-intl)",
    shortLabel: "Alibaba",
    // TokenPlan coding endpoint (International). OpenAI-compatible; aggregates
    // models from Qwen, Zhipu (GLM), Moonshot (Kimi), MiniMax.
    directBaseUrl: "https://coding-intl.dashscope.aliyuncs.com/v1",
    defaultModel: "qwen3.7-plus",
    models: [
      "qwen3.7-plus",
      "qwen3.6-plus",
      "qwen3.5-plus",
      "qwen3-max-2026-01-23",
      "qwen3-coder-next",
      "qwen3-coder-plus",
      "glm-4.7",
      "glm-5",
      "kimi-k2.5",
      "MiniMax-M2.5",
    ],
    authHeader: "Authorization",
    authPrefix: "Bearer ",
    keyHint: "TokenPlan key for the coding-intl endpoint (starts with sk-). Region keys are not interchangeable.",
    signupUrl: "https://bailian.console.alibabacloud.com/",
  },
  xiaomi: {
    id: "xiaomi",
    label: "Xiaomi MiMo",
    shortLabel: "Xiaomi",
    // Token Plan (Singapore), OpenAI-compatible. After buying a Token Plan you
    // may receive an exclusive base URL — paste it over this default in Settings.
    directBaseUrl: "https://token-plan-sgp.xiaomimimo.com/v1",
    defaultModel: "mimo-v2.5-pro",
    // Only the chat models are listed — the asr/tts* models are speech, not
    // /chat/completions, so they don't work with this add-in.
    models: ["mimo-v2.5-pro", "mimo-v2.5"],
    authHeader: "Authorization",
    authPrefix: "Bearer ",
    keyHint: "MiMo key (starts with sk-). Token Plan subscribers get a key + base URL in the Subscription page.",
    signupUrl: "https://mimo.mi.com/",
  },
};

export function getProvider(id) {
  return PROVIDERS[id] || PROVIDERS.alibaba;
}
